import React from "react";
import PropTypes from "prop-types";
import "./toggleSwitch.scss";

const ToggleSwitch = ({
                        id,
                        name = "",
                        checked,
                        onChange,
                        optionLabels = ["Yes", "No"],
                        small = false,
                        disabled = false
                      }) => {

  return (
    <div className={"toggle-switch" + (small ? " small-switch" : "")}>
      <input
        type="checkbox"
        name={name}
        className="toggle-switch__checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      {id ? (
        <label
          className="toggle-switch__label"
          htmlFor={id}
        >
          <span
            className={
              disabled
                ? "toggle-switch__inner toggle-switch__disabled"
                : "toggle-switch__inner"
            }
          />
          <span
            className={
              disabled
                ? "toggle-switch__switch toggle-switch__disabled"
                : "toggle-switch__switch"
            }
            style={{backgroundColor: checked ? '#EAEFFE' : '#454C84'}}
          />
        </label>
      ) : null}
    </div>
  );
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  optionLabels: PropTypes.array,
  small: PropTypes.bool,
  disabled: PropTypes.bool
};

export default ToggleSwitch;
